import React from 'react';

const AwaitingApprovalRow = (props) => {
  const {
    branchCode,
    recordCount
  } = props;

  return (
    <tr
      key={`${branchCode}-row`}
      className="mc-report-data-row"
    >
      <td>{branchCode}</td>
      <td>{recordCount}</td>
    </tr>
  );
};

export default AwaitingApprovalRow;
